export default __webpack_public_path__ + "static/media/milestone 550.45af1952.svg";